import { Hero } from "../../DesktopComponents/Hero/Hero";
import { ServiceList } from "../../../schoolServices/ServiceList";

export const Home = () => {
  return (
    <>
      <Hero />
      <ServiceList />;
    </>
  );
};
